import { redirect } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import { userStore } from "../../store/user";
import { RefundManagerPage } from "./RefundManagerPage";

// Ronin staff only. This page turns on payouts of real money, so the route
// re-checks on entry rather than trusting the nav link being hidden.
const refundManagerAuthGate = async () => {
  const user = userStore.getState().user;
  if (!user) return redirect("/login");
  if (user.role_id !== 1) return redirect("/");
  return null;
};

export const refundManagerRouter = {
  path: "/refund-manager",
  id: "refund-manager",
  element: <RefundManagerPage />,
  loader: requireAuth(undefined, refundManagerAuthGate),
  handle: {
    crumb: () => <Breadcrumb name="Refund Manager" href="/refund-manager" />,
  },
};
